import { render } from "./MetalPlayer.vue?vue&type=template&id=fa9ca082&scoped=true"
import script from "./MetalPlayer.vue?vue&type=script&lang=js"
export * from "./MetalPlayer.vue?vue&type=script&lang=js"

import "./MetalPlayer.vue?vue&type=style&index=0&id=fa9ca082&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9ca082"]])

export default __exports__